import request from "./../utils/request";
import axios from "axios";

const socketRequest = axios.create({
    baseURL: process.env.SOCKET_URL,
    timeout: 20000,
});

export function getSettings() {
    return request.get(`/public/settings/get-all?contain=trigger,all,liveAnalytics`);
}

export function getCountryPhoneInfos() {
    return socketRequest.get(`/phone-infos-country`).then((res) => res.data);
}



// WEBPACK FOOTER //
// ./src/api/setting.js